import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';

// Sub-components moved to AppBarComponents/
import Sitemark from './AppBarComponents/SitemarkIcon';
import AppBarNavItems from './AppBarComponents/AppBarNavItems';
import AppBarActions from './AppBarComponents/AppBarActions';
import AppBarDrawer from './AppBarComponents/AppBarDrawer';

const J = {
    surface: '#111827',
    border: '0.5px solid #294766',
    muted: '#a3d1ff',
};

/**
 * Fixed top AppBar for Jerny.
 */
export default function AppAppBar() {
    const [drawerOpen, setDrawerOpen] = React.useState(false);

    return (
        <AppBar
            position="fixed"
            sx={{
                boxShadow: 0,
                bgcolor: 'transparent',
                backgroundImage: 'none',
                mt: 0,
            }}
        >
            <Container maxWidth="lg">
                <Toolbar
                    variant="dense"
                    disableGutters
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderRadius: '12px',
                        border: J.border,
                        bgcolor: J.surface,
                        px: '12px',
                        py: '5px',
                    }}
                >
                    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                        <Sitemark />
                        <AppBarNavItems />
                    </Box>
                    <AppBarActions />
                    {/* Mobile menu button */}
                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: J.muted }}>
                            <MenuIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>
            <AppBarDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
        </AppBar>
    );
}
